import XRegExp from 'xregexp'

// Blacklist approach: Disallow control characters, certain punctuation, and symbols.
// This regex blocks control characters (\p{C}), and you might want to add specific symbols or punctuation marks to block.
// Adjust the regex to fit your specific needs. For example, adding \p{P} would block all punctuation, which might be too broad.
const regOnlyEngAndArChars = XRegExp('^[^\\p{C}\\p{S}\\p{P}]*$')

export default regOnlyEngAndArChars
